import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { config } from '../../config';

export default function GestionClesPat() {
  const [cles, setCles] = useState([]);
  const [patList, setPatList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({ id_pat: '', expiration_days: '' });

  // Utilisation de la configuration centralisée
  const API_BASE = config.apiBase;

  const fetchData = async () => {
    const token = localStorage.getItem('token');
    try {
      const [clesRes, patRes] = await Promise.all([
        fetch(`${API_BASE}/admin/pat/cles/lister.php`, {
          headers: { 'Authorization': `Bearer ${token}` }
        }),
        fetch(`${API_BASE}/admin/pat/lister.php`, {
          headers: { 'Authorization': `Bearer ${token}` }
        })
      ]);
      const clesData = await clesRes.json();
      const patData = await patRes.json();
      if (clesData.success) setCles(clesData.cles);
      if (patData.success) setPatList(patData.pat);
    } catch (error) {
      toast.error('Erreur de chargement');
    } finally {
      setLoading(false);
    }
  };

  const genererCle = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('token');
    try {
      const response = await fetch(`${API_BASE}/admin/pat/cles/creer.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(formData)
      });
      const data = await response.json();
      if (data.success) {
        toast.success(`Clé générée : ${data.cle_unique}`);
        setShowForm(false);
        setFormData({ id_pat: '', expiration_days: '' });
        fetchData();
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      toast.error('Erreur lors de la génération');
    }
  };

  const desactiverCle = async (id_cle) => {
    const token = localStorage.getItem('token');
    try {
      const response = await fetch(`${API_BASE}/admin/pat/cles/desactiver.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ id_cle })
      });
      const data = await response.json();
      if (data.success) {
        toast.success('Clé désactivée');
        fetchData();
      }
    } catch (error) {
      toast.error('Erreur');
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (loading) return <div className="p-6 text-center">Chargement...</div>;

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-primary">Gestion des clés PAT</h1>
        <button onClick={() => setShowForm(true)} className="bg-primary text-white px-4 py-2 rounded-lg">
          + Générer une clé
        </button>
      </div>

      {showForm && (
        <div className="bg-white rounded-lg shadow-md p-6 mb-6">
          <h2 className="text-lg font-semibold mb-4">Nouvelle clé d'activation</h2>
          <form onSubmit={genererCle} className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <select
              value={formData.id_pat}
              onChange={(e) => setFormData({ ...formData, id_pat: e.target.value })}
              className="border rounded-lg px-3 py-2"
              required
            >
              <option value="">Sélectionner un PAT</option>
              {patList.map(pat => (
                <option key={pat.id_utilisateur} value={pat.id_utilisateur}>
                  {pat.prenom} {pat.nom} - {pat.institution || 'Sans institution'}
                </option>
              ))}
            </select>
            <input
              type="number"
              placeholder="Durée de validité (jours, laisser vide pour illimitée)"
              value={formData.expiration_days}
              onChange={(e) => setFormData({ ...formData, expiration_days: e.target.value })}
              className="border rounded-lg px-3 py-2"
            />
            <div className="md:col-span-2 flex gap-2">
              <button type="submit" className="bg-green-600 text-white px-4 py-2 rounded-lg">Générer</button>
              <button type="button" onClick={() => setShowForm(false)} className="bg-gray-400 text-white px-4 py-2 rounded-lg">Annuler</button>
            </div>
          </form>
        </div>
      )}

      <div className="overflow-x-auto bg-white rounded-lg shadow">
        <table className="min-w-full">
          <thead className="bg-gray-50">
            <tr><th className="px-6 py-3">PAT</th><th className="px-6 py-3">Clé unique</th><th className="px-6 py-3">Générée par</th><th className="px-6 py-3">Date génération</th><th className="px-6 py-3">Expiration</th><th className="px-6 py-3">Statut</th><th className="px-6 py-3">Actions</th></tr>
          </thead>
          <tbody>
            {cles.map(cle => (
              <tr key={cle.id_cle} className="border-b hover:bg-gray-50">
                <td className="px-6 py-4">{cle.prenom} {cle.nom} (<span className="text-xs text-gray-500">{cle.email}</span>)</td>
                <td className="px-6 py-4 font-mono text-sm">{cle.cle_unique}</td>
                <td className="px-6 py-4">{cle.generateur_nom}</td>
                <td className="px-6 py-4 text-sm">{new Date(cle.date_generation).toLocaleDateString()}</td>
                <td className="px-6 py-4 text-sm">{cle.date_expiration ? new Date(cle.date_expiration).toLocaleDateString() : 'Illimitée'}</td>
                <td className="px-6 py-4">{cle.est_active ? <span className="bg-green-100 text-green-800 px-2 py-1 rounded-full text-xs">Active</span> : <span className="bg-red-100 text-red-800 px-2 py-1 rounded-full text-xs">Désactivée</span>}</td>
                <td className="px-6 py-4">
                  {cle.est_active && (
                    <button onClick={() => desactiverCle(cle.id_cle)} className="bg-red-600 text-white px-3 py-1 rounded text-sm">Désactiver</button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}